import { Component } from '@angular/core';


interface AdminActivity {
  timestamp: Date;
  user: string;
  action: string;
  status: 'Success' | 'Failed';
}

@Component({
  selector: 'app-lecturerdashboard',
  templateUrl: './lecturerdashboard.component.html',
  styleUrls: ['./lecturerdashboard.component.scss']
})



export class LecturerdashboardComponent {
  currentUser: any;


  
  lcdStats = [
    { label: 'Courses', value: 0 },
    { label: 'Students', value: 0 },
    { label: 'Pending Reviews', value: 0 }
  ];
  lcdCourses = [
    { name: 'Algorithms & Data Structures', students: 0 },
    { name: 'Computer Networks', students: 0 },
    { name: 'Web Development', students: 0 },
    { name: 'Discrete Mathematics', students: 0 },
    { name: 'Software Engineering', students: 0 }
  ];


    public loading = false;


    public loaderConfig = {
    animationType: 'circleSwish',
    backdropBorderRadius: '2px',
    primaryColour: '#630f12',
    secondaryColour: '#630f12',
    tertiaryColour: '#ffcb05',
    backdropBackgroundColour: 'rgba(0, 0, 0, 0.5)',
    fullScreenBackdrop: true
  };

   // Recent Activities
  recentActivities: AdminActivity[] = [];

  // Debug Info
  currentTime: Date = new Date();


 ngOnInit(): void {
    this.loadUserData();
    this.loadDashboardData();
  }

  loadUserData(): void {
    // Get user from localStorage or set default
    const userStr = localStorage.getItem('sysadmin_user');
    this.currentUser = userStr ? JSON.parse(userStr) : { username: 'Registrar' };
  }

  loadDashboardData(): void {
    this.loading = true;
    // Simulate API call
    setTimeout(() => {
      this.loading = false;
    }, 1000);
  }


}
